(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fotric-product-benefits"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fotric-delivery-estimate')) {
  customElements.define('fotric-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.updateDates();
      this.timer = setInterval(() => this.updateDates(), 60000);
      this.onVisible = () => { if (!document.hidden) this.updateDates(); };
      document.addEventListener('visibilitychange', this.onVisible);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onVisible);
    }
    updateDates() {
      const now = new Date();
      const base = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
      const key = base.toISOString().slice(0,10);
      if (this.day === key) return;
      const locale = this.dataset.locale || 'en';
      let format;
      try { format = new Intl.DateTimeFormat(locale, {month:'short',day:'numeric',timeZone:'UTC'}); }
      catch { format = new Intl.DateTimeFormat('en', {month:'short',day:'numeric',timeZone:'UTC'}); }
      const offset = days => { const value = new Date(base); value.setUTCDate(value.getUTCDate()+days); return format.format(value); };
      const values = {ordered:offset(0),ready:offset(2),delivered:offset(7)+' – '+offset(9)};
      for (const [name,value] of Object.entries(values)) this.querySelector('[data-date="'+name+'"]').textContent=value;
      this.querySelector('ol').hidden=false;
      this.day=key;
    }
  });
}

if (!customElements.get('fotric-benefits-info')) {
  customElements.define('fotric-benefits-info', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('.fotric-benefits__help');
      const restore = () => {
        document.documentElement.style.overflow = this.oldOverflow ?? '';
        if(trigger.isConnected) trigger.focus({preventScroll:true});
      };
      const close = () => { dialog.close(); restore(); };
      trigger.addEventListener('click', () => {
        this.oldOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        dialog.scrollTop = 0;
        document.documentElement.style.overflow = 'hidden';
      }, options);
      this.querySelector('.fotric-benefits__close').addEventListener('click',close,options);
      dialog.addEventListener('keydown', e => {
        if(e.key !== 'Tab') return;
        const items = [...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),[tabindex="0"]')].filter(el=>el.getClientRects().length);
        const first=items[0], last=items[items.length-1];
        if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}
        else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}
      },options);
      dialog.addEventListener('click', e => {
        const rect = dialog.getBoundingClientRect();
        if(e.target === dialog && (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom)) close();
      },options);
      dialog.addEventListener('cancel', e => {e.preventDefault();close();},options);
    }
    disconnectedCallback() {
      if(this.querySelector('dialog')?.open) document.documentElement.style.overflow = this.oldOverflow ?? '';
      this.abort?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
